import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import CategoriesSuper from '../Categories/CategoriesSuper';
import { getLabConfig, getCategories } from '../../utils/api';

import MenuContext from '../../store/MenuContext';
import CategoryMenuClasses from '../Categories/CategoryMenu.module.css';


const CTS_CustomComplete = () => {
	const navigate = useNavigate();
	const menuTheme = useContext(MenuContext);

    return (
		<div className={CategoryMenuClasses.categoryItemHeaderColumn}>
			<strong>
			<div>Please complete both steps below to finalize your order:</div>
			<div>
				1.  Print your order requisition<br />
				2.  Pick a location to schedule your specimen collection.
				<br/>
				Call us at 833-728-9800 if you are having any issues completing this section.
			</div>
			</strong>
		</div>
    );
};

export default CTS_CustomComplete;